module.exports = __webpack_public_path__ + "img/cb4-2-l-rr1-off.0f28bdad.gif";